'use strict';
const angular = require('angular');

const uiRouter = require('angular-ui-router');

import routes from './document-upload.routes.js';

export class DocumentUploadComponent {
  /*@ngInject*/
  constructor(Upload, Auth, DocumentService, $state, $stateParams, Config, $window) {
    this.baseContainerClass = Config.getPlatformConfig().getBaseContainerClass();
    this.Upload = Upload;
    this.Auth = Auth;
    this.DocumentService = DocumentService;
    this.type = $stateParams.type;
    this.back = _ => $window.history.back();

    this.allowedMimeTypes = Config.getPlatformConfig().getAllowedContentTypesForUpload().join(',');

    var documentConfig = Config.getModuleConfig(Config.Modules.Document);

    this.pageTitle = Config.getPageTitleByStateWithDefault($state.current.name, "Document Upload");

    this.permissionModel = {};
    this.roles = Config.getPlatformConfig().getPermissionRoles();
    this.defaultUploadUserPermission = Config.getPlatformConfig().getDefaultPermissionUserUpload();
    this.defaultPermissionByType = documentConfig.getDefaultPermissionByType();
    this.roles.forEach(role => {
      this.permissionModel[role] = this.defaultUploadUserPermission.includes(role);
    });

    // Enumeration with possible document types
    this.documentType = documentConfig.getTypes();
    this.documentPageCategories = documentConfig.getPageCategories();

    this.docTypesEnum = [];
    if (this.documentPageCategories && Object.keys(this.documentPageCategories).length) {
      let keys = Object.keys(this.documentPageCategories);
      keys.forEach(key => {
        if (this.documentPageCategories.hasOwnProperty(key)) {
          let types = this.documentPageCategories[key];
          types.forEach(type => {
            this.docTypesEnum.push({
              value: type,
              group: key
            });
          });
        }
      })
    } else {
      this.docTypesEnum = this.documentType.map(type => {return {value: type, group:'Categories'}});
    }

    this.documentTemplate = {
      type: this.type || documentConfig.getDefaultUploadType(),
      orderNumber: 100,
      meta: {
        creationUser: Auth.getCurrentUserSync()._id,
        active: true
      }
    };

    this.document = angular.copy(this.documentTemplate);
    this.submitted = false;
    this.typeChanged(); // trigger initally to set defaults
  }

  typeChanged() {
    let type = this.document.type;
    if (this.defaultPermissionByType[type]) {
      let defaultRoles = angular.isArray(this.defaultPermissionByType[type])
        ? this.defaultPermissionByType[type]
        : [this.defaultPermissionByType[type]];
      this.roles.forEach(role => {
        this.permissionModel[role] = defaultRoles.includes(role);
      })
    } else {
      this.roles.forEach(role => {
        this.permissionModel[role] = this.defaultUploadUserPermission.includes(role);
      });
    }
  }

  upload(form) {

    this.submitted = true;
    this.sendSuccess = false;
    this.sendFailure = false;

    if (form.$valid) {

      let permission = [];

      if (!this.document.isPublic) {
        for (let role in this.permissionModel) {
          if (this.permissionModel.hasOwnProperty(role)) {
            if (this.permissionModel[role] === true){
              permission.push(role);
            }
          }
        }
      }

      this.Upload.upload({
        url: '/api/storage',
        data: {
          name: this.documentFile.name,
          file: this.documentFile,
          storageStrategy: 'local',
          permission: permission.join(','),
          isPublic: this.document.isPublic,
          creationUser: this.Auth.getCurrentUserSync()._id,
          active: true
        }
      }).then(
        (res) => {

          this.document.document = res.data;

          this.DocumentService.save(this.document, () => {
              this.document = angular.copy(this.documentTemplate);
              delete this.documentFile;
              this.submitted = false;
              this.sendSuccess = true;
            },
            (err) => {
              this.sendFailure = true;
            })

        },
        (err) => {
          this.sendFailure = true;
        });

    }

  }

}

export default angular.module('conduuApp.documentUpload', [uiRouter])
  .config(routes)
  .component('documentUpload', {
    template: require('./document-upload.html'),
    controller: DocumentUploadComponent,
    controllerAs: 'ctrl'
  })
  .name;



// WEBPACK FOOTER //
// ./client/app/document/upload/document-upload.component.js